import WidgetModalUserDelete from "./UserDelete";
import {ModalType} from "../../entities/common";
import { useSelector } from 'react-redux';
import {IRootStore} from "../../store/Root.reducer";
import WidgetModalSensorDelete from "./SensorDelete";
import WidgetModalZoneDelete from "./ZoneDelete";
import WidgetModalObjectDelete from "./ObjectDelete";
import WidgetModalQuestionnaireDelete from "./QuestionnaireDelete";
import WidgetModalGatewayDelete from "./GatewayDelete";
import WidgetModalGatewayConfig from "./GatewayConfig";
import WidgetModalPageLeave from "./PageLeave";

const WidgetModal = () => {
  const { modalType, modalProps, active } = useSelector(
    (state: IRootStore) => state.modal,
  );

  const renderModal = () => {
    switch (modalType) {
      case ModalType.USER_DELETE:
        return (
          <WidgetModalUserDelete
            isVisible={modalType === ModalType.USER_DELETE && active}
            {...modalProps}
          />
        );
      case ModalType.SENSOR_DELETE:
        return (
          <WidgetModalSensorDelete
            isVisible={modalType === ModalType.SENSOR_DELETE && active}
            {...modalProps}
          />
        );
      case ModalType.ZONE_DELETE:
        return (
          <WidgetModalZoneDelete
            isVisible={modalType === ModalType.ZONE_DELETE && active}
            {...modalProps}
          />
        );  
      case ModalType.OBJECT_DELETE:
        return (
          <WidgetModalObjectDelete
            isVisible={modalType === ModalType.OBJECT_DELETE && active}
            {...modalProps}
          />
        );
      case ModalType.QUESTIONNAIRE_DELETE:
        return (
          <WidgetModalQuestionnaireDelete
            isVisible={modalType === ModalType.QUESTIONNAIRE_DELETE && active}
            {...modalProps}
          />
        );
      case ModalType.GATEWAY_DELETE:
        return (
          <WidgetModalGatewayDelete
            isVisible={modalType === ModalType.GATEWAY_DELETE && active}
            {...modalProps}
          />
        );
      case ModalType.GATEWAY_CONFIG:
        return (
          <WidgetModalGatewayConfig
            isVisible={modalType === ModalType.GATEWAY_CONFIG && active}
            {...modalProps}
          />
        );
      case ModalType.PAGE_LEAVE:
        return (
          <WidgetModalPageLeave
            isVisible={modalType === ModalType.PAGE_LEAVE && active}
            {...modalProps}
          />
        );
      default:
        return null;
    }
  };

  return renderModal();
};

export default WidgetModal;
